// extracted by mini-css-extract-plugin
export var actions = "_qp-4";
export var item = "_qp-1";
export var price = "_qp-3";
export var quantity = "_qp-2";
export var table = "_qp-0";